interface AppSettings {
  [index: string]: any;

  enableLogging: boolean;
}

export const appSettings: AppSettings = {
  enableLogging: true
};

// @ts-ignore
window.AppSettings = appSettings;
